import { RiArrowGoBackFill } from 'react-icons/ri'
import { BsUiChecks, BsClipboardCheck, BsCheck2Circle, BsBootstrapReboot } from 'react-icons/bs'
import { FaList, FaUsers } from 'react-icons/fa'
import { FcDisclaimer, FcApproval } from 'react-icons/fc'
import { MdPostAdd, MdOutlinePropaneTank } from 'react-icons/md'
import { GoPackage } from 'react-icons/go'
import { AiOutlineStop } from 'react-icons/ai'
import { HiDocumentReport } from 'react-icons/hi'
import { HiOutlineClipboardDocumentList } from 'react-icons/hi2'
import { GiMagnifyingGlass } from "react-icons/gi";

export const OrderType = {
  ALL: "ทั้งหมด",
  BULK: "BULK",
  FG: "FG"
}

export const OrderStatusDisplay = {
  PD_READY: 'พร้อมผลิต',
  PD_IN_PROGRESS: 'กำลังผลิต',
  PD_DRAFTED: 'ผลิตจบแล้ว',
  PD_CONFIRMED: 'ยืนยันแล้ว',
  PD_CANCELED: 'ยกเลิก',
  ALL: 'ทั้งหมด'
}

export const OrderStatusDisplayPdLeaderline = {
  ALL: 'ทั้งหมด',
  PD_READY: 'พร้อมผลิต',
  PD_IN_PROGRESS: 'กำลังผลิต',
  PD_DRAFTED: 'ผลิตจบแล้ว'
}

export const OrderStatusDisplayPdAdmin = {
  PD_READY: 'พร้อมผลิต',
  PD_IN_PROGRESS: 'กำลังผลิต',
  PD_DRAFTED: 'ผลิตจบแล้ว รอยืนยัน',
  PD_CONFIRMED: 'ยืนยันแล้ว',
  PD_CANCELED: 'ยกเลิก'
}

export const DefaultOrderStatus = {
  LeaderLines: "PD_READY",
  Leaderline: "PD_READY"
}

export const OrderStatusForAdminDisplay = {
  PD_DRAFTED: 'ผลิตจบแล้ว',
  PD_CONFIRMED: 'ยืนยันแล้ว',
}

export const OrderReasonCodeStatusDisplay = {
  PD_DRAFTED: 'ผลิตจบแล้ว',
  PD_CONFIRMED: 'ยืนยันแล้ว',
}

export const OrderStatusCode = {
  READY: 'PD_READY',
  IN_PROGRESS: 'PD_IN_PROGRESS',
  DRAFTED: 'PD_DRAFTED',
  CONFIRMED: 'PD_CONFIRMED'
}
export const AllowOrderStatus = {
  LeaderLines: [OrderStatusCode.READY, OrderStatusCode.IN_PROGRESS, OrderStatusCode.DRAFTED],
  Leaderline: [OrderStatusCode.READY, OrderStatusCode.IN_PROGRESS, OrderStatusCode.DRAFTED],
  Admins: [OrderStatusCode.DRAFTED, OrderStatusCode.CONFIRMED],
  Admin: [OrderStatusCode.DRAFTED, OrderStatusCode.CONFIRMED]
}

export const OrderStatusTheme = {
  PD_READY: 'outline-primary',
  PD_IN_PROGRESS: 'primary',
  PD_DRAFTED: 'outline-success',
  PD_CONFIRMED: 'success',
  PD_CANCELED: 'secondary'
}

export const MaxOrderSelectedDay = 30

export const ErrorOrderSelectDay = {
  START_DATE_INVALID: 'เลือกวันที่เริ่มไม่ถูกต้อง กรุณาเลือกใหม่',
  END_DATE_INVALID: 'เลือกวันที่จบไม่ถูกต้อง กรุณาเลือกใหม่',
  OUT_OF_SCOPE: `ไม่สามารถจำนวนวันเกิน ${MaxOrderSelectedDay} วันได้`,
}

export const Documents = {
  PRODUCTION_PROCESS: 'Production Process',
  PRODUCTION_PROCESS_CONFIRM: 'ข้อมูลบันทึกการผลิต',
  PRODUCTION_ORDER_PICKLIST: 'Production Order Picklist',
  PRODUCTION_QC_FG: 'ใบตรวจสอบคุณภาพสินค้า'
}

export const UserRoleColor = {
  PD_ADMIN: "admin",
  PD_LEADER_LINE: "leaderline"
}

export const OperationTime = {
  SETUP_TIME: 'Set Up',
  RUN_TIME: 'Run Time',
  DOWN_TIME: 'Down Time',
  SOAP_BASE: 'Soap Base'
}

export const OperationTimeQC = {
  INSPECT_BULK: 'Inspect Bulk'
}

export const LaborTimeType = {
  RT: 'RT',
  OT: 'OT'
}

export const EditSapMasterStatusDisplay = {
  ALL: 'ทั้งหมด',
  EDIT_WC: 'WC',
  EDIT_OPERATION: 'OP'
}

export const EditSapMasterStatusTheme = {
  EDIT_WC: 'warning',
  EDIT_OPERATION: 'info'
}

export const Division = {
  ALL: 'ทั้งหมด',
  HHD: 'HHD-Household',
  TLT: 'TLT-Toiletry'
}

export const DivisionValue = {
  HHD: 'Household',
  TLT: 'Toiletry'
}

export const DivisionTheme = {
  Household: 'warning',
  Toiletry: 'info'
}

export const MainMenu = [
  { title: '1.Batch No', value: 'edit_batch_no'},
	{ title: '2.บันทึกเวลาผลิต', value: 'operation'},
	{ title: '3.เบิกเพิ่ม', value: 'extra' },
	{ title: '4.บันทึกของเสีย', value: 'reason_code'},
	{ title: '5.บันทึกยอดใช้ดี/เสีย', value: 'picklist' },
  { title: '6.สรุป Receipt', value: 'retain_record', isNew: true },
	{ title: '7.Comment', value: 'comment' },
]

export const MainMenuAdmin = [
  { title: '1.Batch No', value: 'edit_batch_no'},
	{ title: '2.ยืนยันข้อมูลเวลาผลิต', value: 'operation'},
	{ title: '3.ยืนยันข้อมูลของเสีย', value: 'reason_code'},
  { title: '4.รายการเบิกเพิ่ม', value: 'extra' },
  { title: '5.ตรวจสอบยอดใช้ดี/เสีย', value: 'picklist' },
  { title: '6.สรุป Receipt', value: 'retain_record', isNew: true },
  { title: '7.Comment', value: 'comment' }
]

export const Shift = [
  "0-Day", "1-กลางวัน", "2-กลางคืน", "3-กลางคืน"
]

export const NavMenus = [
  { 
    title: 'Order พร้อมผลิต',
    path: 'order-ready',
    description: 'Line การผลิตบันทึกเวลาการผลิต',
    logo: BsClipboardCheck, 
    color: ' fill-green-500',
    category: 'order-ready',
    active: true
  },
  { 
    title: 'Order รอการยืนยัน', 
    path: 'order-wait-confirm',
    description: 'PD Admin ตรวจสอบและยืนยัน Order ไปยัง SAP',
    logo: BsClipboardCheck, 
    color: ' fill-green-500',
    category: 'order-wait-confirm',
    active: true
  },
  { 
    title: 'จัดการข้อมูล Order', 
    path: 'master',
    description: 'จัดการข้อมูล Production Order',
    logo: FaList, 
    color: ' fill-blue-500',
    category: 'master',
    active: true
  },
  { 
    title: 'จัดการผู้ใช้งาน', 
    path: 'users',
    description: 'จัดการผู้ใช้งานในระบบ',
    logo: FaUsers, 
    color: ' fill-yellow-500',
    category: 'users',
    active: true
  },
  { title: 'PD - อนุมัติเบิก', path: 'picklist-approve',
    description: 'อนุมัติใบเบิกของ Order ที่ต้องการผลิต ส่งไปยัง Warehouse',
    logo: BsClipboardCheck, color: ' fill-red-500',
    category: 'picklist-approve', active: true },
  { title: 'PD - ตรวจสอบใบเบิก', path: 'picklist-check',
    description: 'ตรวจสอบ RM/PK ที่ส่งมาจาก Warehouse',
    logo: BsUiChecks, color: 'fill-yellow-400',
    category: 'picklist-check', active: true  },
  { title: 'QC - ตรวจสอบ RM ก่อนผสม', path: 'picklist-qa-check',
    description: 'ตรวจสอบ RM ก่อนผสม',
    logo: BsUiChecks, color: 'fill-red-400',
    category: 'picklist-qa-check', active: true  },
  { title: 'PD - ปิด Order', path: 'picklist-complete',
    description: 'ปิดเอกสารใบเบิกที่ผลิตจบแล้ว และอนุมัติคืน',
    logo: BsCheck2Circle, color: 'fill-green-500',
    category: 'picklist-complete', active: true  },
  { title: 'WH - อนุมัติคืน', path: 'picklist-return',
    description: 'ตรวจสอบยอดคืนจาก Production',
    logo: RiArrowGoBackFill, color: 'fill-green-300',
    category: 'picklist-return', active: true  },
  { title: 'PD - อนุมัติเบิกเพิ่ม', path: 'picklist-extra',
    description: 'อนุมัติคำร้องขอเบิกเพิ่มจาก LINE ผลิต ส่งไปยัง Warehouse',
    logo: MdPostAdd, color: ' fill-yellow-500',
    category: 'picklist-extra', active: true  },
  { title: 'รายงาน', path: 'report',
    description: 'รายงาน Production Order',
    logo: HiDocumentReport, color: ' fill-red-500',
    category: 'report', active: true  },
  { title: 'รายการ PD Order ที่มีคืนเสีย PKG', path: 'waste-return',
    description: 'รายการ PD Order ที่มียอด Packaging คืนเสียกลับเข้าคลัง',
    logo: FcDisclaimer, color: ' fill-red-500',
    category: 'waste-return', active: true  },
  { title: 'ใบเบิก', path: 'picklist-detail',
    description: 'ภาพรวม ใบเบิก',
    logo: HiOutlineClipboardDocumentList, color: '',
    category: 'picklist-detail', active: true  },
  { title: 'อนุมัติรายการ QC-Bulk', path: 'bulk-inspection',
    description: 'อนุมัติรายการ QC-Bulk',
    logo: BsUiChecks, color: 'fill-rose-400',
    category: 'bulk-inspection', active: true  },
  { 
    title: 'อนุมัติจ่าย RM',
    description: 'อนุมัติจ่าย RM ไปยัง Order ที่ PD ต้องการ',
    path: 'good-issue-order/bulk',
    category: 'good-issue-order',
    categoryTitle: 'WH - อนุมัติจ่าย',
    logo: MdOutlinePropaneTank, 
    color: 'fill-yellow-300', active: true 
  },
  { 
    title: 'อนุมัติจ่าย PKG',
    description: 'อนุมัติจ่าย PKG ไปยัง Order ที่ PD ต้องการ',
    path: 'good-issue-order/fg',
    category: 'good-issue-order',
    categoryTitle: 'WH - อนุมัติจ่าย',
    logo: GoPackage, 
    color: 'fill-blue-300', active: true 
  },
  { 
    title: 'อนุมัติจ่าย CLAIM',
    path: 'good-issue-order/claim',
    description: 'อนุมัติจ่าย FG ไปยัง Order ที่ PD ต้องการ',
    category: 'good-issue-order',
    categoryTitle: 'WH - อนุมัติจ่าย',
    logo: AiOutlineStop, 
    color: 'fill-red-400', active: true 
  },
  { 
    title: 'อนุมัติจ่าย REPACK',
    path: 'good-issue-order/repack',
    description: 'อนุมัติจ่าย Component ไปยัง Order ที่ PD ต้องการ',
    category: 'good-issue-order',
    categoryTitle: 'WH - อนุมัติจ่าย',
    logo: BsBootstrapReboot, 
    color: 'fill-amber-100', active: true  
  },
  { 
    title: 'อนุมัติคืน CLAIM',
    path: 'good-reverse-order/claim',
    description: 'ตรวจสอบยอดคืน FG จาก Production',
    category: 'good-reverse-order',
    categoryTitle: 'WH - อนุมัติคืน FG',
    logo: AiOutlineStop, 
    color: 'fill-red-400',
    active: false
  },
  { 
    title: 'อนุมัติคืน REPACK',
    path: 'good-reverse-order/repack',
    description: 'ตรวจสอบยอดคืน FG จาก Production',
    category: 'good-reverse-order',
    categoryTitle: 'WH - อนุมัติคืน FG',
    logo: BsBootstrapReboot, 
    color: 'fill-amber-100',
    active: false
  },
  { 
    title: 'รายการ ORDER CLAIM - เลือก Inspection Form ให้กับ Claim Order',
    path: 'order-claim',
    description: 'เลือก Inspection Form ให้กับ Claim Order',
    category: 'order-claim',
    categoryTitle: 'QC - Claim',
    logo: AiOutlineStop, 
    color: 'fill-red-300', active: true 
  },
  { 
    title: 'ตรวจคุณภาพ FG', path: 'fg-inspection',
    description: 'ตรวจคุณภาพ FG (Filling / Packing)',
    logo: GiMagnifyingGlass, color: ' fill-red-500',
    category: 'fg-inspection', active: true 
  },
  {
    title: 'อนุมัติใบ Receipt', path: 'order-receipt-approval',
    description: 'อนุมัติใบ Receipt สินค้า',
    logo: FcApproval, color: 'fill-rose-400',
    category: 'order-receipt-approval', active: true 
  }
]

export const DepartmentRoles = {
  'Production': ['TeamLeader', 'Checker', 'Leaderline', 'Admin', 'Inspector', 'Reviewer'],
  'Warehouse': ['Inventory', 'Admin'],
  'QC': ['Leaderline', 'Inspector', 'Reviewer', 'Approver', 'Admin'],
  'FA': ['Admin', 'Reviewer', 'Approver', 'Picklist'],
  'PM': ['Leaderline', 'Admin'],
  'IT': ['Leaderline', 'Admin'],
  'PL': ['Leaderline', 'Admin', 'Picklist'],
  'PO': ['Admin'],
  'RD': ['Picklist'],
  'PK': ['Picklist'],
  'QS': ['Reviewer']
}

export const Tags = {
  PARTIAL: 'Partial'
}

export const QCDowntimeCodes = ['180', '188']

export const ReasonType = {
  PLAN: 'PLAN',
  UNPLAN: 'UNPLAN'
}

// loss group ของ reason code (คอลัมน์ Loss group)
export const LossGroup = {
  CHANGE: 'เปลี่ยน',
  RUN_TIME: 'Run Time',
  CLEANING: 'Cleaning',
  MEETING_STOP: 'Meeting / Stop',
  PLANNING: 'Planning',
  PREPARATION: 'Preparation',
  PD: 'PD',
  QC: 'QC',
  SAFETY: 'SF',
  WAREHOUSE: 'WH',
  PURCHASING: 'จัดซื้อ',
  TRIAL_VALIDATION: 'Trial / Validation',
  UTILITY_FACILITY: 'Utility/Facility',
  ADJUST_PD: 'ปรับเครื่อง-PD',
  BREAKDOWN_EN: 'หยุดซ่อม-EN',
  OTHER: 'Other'
}

// Reason codes ทั้งหมด (ส่งเป็น REASON_VAR ไป SAP) — อ้างอิงไฟล์
// "1_Downtime list_Revise Aug26" tab "Code Revised Ver3"
// เก็บเป็น list แบน ๆ แล้วใช้ timeType + lossGroup + workCenterCategories กรองเอา
// workCenterCategories = คอลัมน์ Zxxx ในไฟล์ ใช้กรอง dropdown ให้ตรงกับ work center ของ order
// machine = ชื่อเรียกของ pattern Zxxx ชุดนั้น ก็อปตามไฟล์ต้นทาง 100% (สะกดไม่ตรงกันบางแถว)
// เก็บเป็น string ตรง ๆ ไม่ทำ enum เพราะ category ฝั่ง SAP จะเพิ่มได้อีกเรื่อย ๆ
// ที่ใช้อยู่ตอนนี้: Z001 Mix, Z002 Storage, Z003 Shrink, Z004 Fill, Z005, Z006 WPK,
// Z007 STK, Z009 Filter, Z011 FFS
// ถ้า work center ยังไม่ได้ระบุ category จะโชว์ทุก code
// ทุก code ใช้ได้ทั้ง plant HHD และ TLT จึงไม่เก็บ field plant
// TODO: ย้ายไปเป็น master model เมื่อ scope/category ของ reason code ชัดเจนแล้ว
// TODO (phase 4): ให้ฟอร์ม downtime มาอ่าน list นี้แทน DgtPdDowntimeCode
export const ReasonCodes = [
  {
    code: '0001',
    activity: 'เปลี่ยน lot / เปลี่ยน Order / เปลี่ยนถัง Bulk',
    timeType: OperationTime.SETUP_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.CHANGE,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '0002',
    activity: 'เปลี่ยนไซส์',
    timeType: OperationTime.SETUP_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.CHANGE,
    machine: 'Shrink, Fill, Sticker, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z007', 'Z011']
  },
  {
    code: '0003',
    activity: 'เปลี่ยนสูตร',
    timeType: OperationTime.SETUP_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.CHANGE,
    machine: 'Filling Machine',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '0004',
    activity: 'เปลี่ยนไซส์และสูตร',
    timeType: OperationTime.SETUP_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.CHANGE,
    machine: 'Shrink, Fill, Sticker, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z007', 'Z011']
  },
  {
    code: '9999',
    activity: 'Run Time',
    timeType: OperationTime.RUN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.RUN_TIME,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z005', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1000',
    activity: 'หยุดงานตามแผนการผลิต',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.MEETING_STOP,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1001',
    activity: 'เข้ากะสั้น',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.MEETING_STOP,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1002',
    activity: 'หยุดเปลี่ยนแผนการผลิต',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PLANNING,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1003',
    activity: 'วันหยุด',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.MEETING_STOP,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1004',
    activity: 'พักเบรค',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.MEETING_STOP,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1005',
    activity: 'ต่อกะ-เปลี่ยนกะ',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.PREPARATION,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1006',
    activity: 'เตรียมเครื่องเปิดสัปดาห์',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.PREPARATION,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1007',
    activity: 'ทำความสะอาดปิดสัปดาห์',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.CLEANING,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1008',
    activity: 'ล้างเครื่องตามรอบ',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.CLEANING,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1009',
    activity: '5ส หยุดไลน์ ทำความสะอาด / ทิ้งขยะ',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.CLEANING,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1010',
    activity: 'ประชุม อบรม กิจกรรมของ HR',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.MEETING_STOP,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1011',
    activity: 'ประชุม อบรม Daily Talk กิจกรรมของ PD',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.MEETING_STOP,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1012',
    activity: 'กิจกรรมปรับปรุงการผลิตของ PD',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.PD,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1013',
    activity: 'ประชุม อบรม กิจกรรมของ QS',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.MEETING_STOP,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1014',
    activity: 'อพยพจากเหตุภัยพิบัติ',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.SAFETY,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '1015',
    activity: 'ประชุม อบรม กิจกรรมของ Safety',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.SAFETY,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '2001',
    activity: 'แก้งาน/คัดงานมีปัญหาจาก PD',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PD,
    machine: 'Shrink, Fill, WPK, STK, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z006', 'Z007', 'Z011']
  },
  {
    code: '2002',
    activity: 'รอขนย้าย  bulk',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PD,
    machine: 'Shrink, Fill, WPK, STK, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z006', 'Z007', 'Z011']
  },
  {
    code: '2003',
    activity: 'รอ bulk จาก Mix / รอ Mix Bulk',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PD,
    machine: 'Shrink, Fill, WPK, STK, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z006', 'Z007', 'Z011']
  },
  {
    code: '2004',
    activity: 'รอขนย้าย Package / รอเบิก Package เพิ่ม',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PD,
    machine: 'Shrink, Fill, WPK, STK, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z006', 'Z007', 'Z011']
  },
  {
    code: '2005',
    activity: 'เปลี่ยนม้วนฟิล์ม/Sticker/Shrink',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PD,
    machine: 'Shrink, Fill, WPK, STK, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z006', 'Z007', 'Z011']
  },
  {
    code: '2006',
    activity: 'รอคนเสริมไลน์',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PD,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '2007',
    activity: 'คนไม่พอ',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PD,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '2008',
    activity: 'ปัญหาคุณภาพ bulk จาก PD',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PD,
    machine: 'Mix, Storage, Fill, Fllter, FFS',
    workCenterCategories: ['Z001', 'Z002', 'Z004', 'Z009', 'Z011']
  },
  {
    code: '2009',
    activity: 'Bulk เป็นฟองทำให้  fill ไม่ได้',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PD,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '2010',
    activity: 'รอเก็บ Bulk ส่งตรวจสอบ',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.PD,
    machine: 'Mix, Storage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '2011',
    activity: 'รอขนย้าย RM รอจัดเตรียมชุด RM ก่อนผสม',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PD,
    machine: 'Mix, Storage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '2012',
    activity: 'รอเบิก RM เพิ่ม',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PD,
    machine: 'Mix, Storage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '2013',
    activity: 'รอเปลี่ยนม้วน shrink',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PD,
    machine: 'STK, Fill',
    workCenterCategories: ['Z003', 'Z004']
  },
  {
    code: '2014',
    activity: 'รอเปลี่ยนม้วนฉลาก/Sticker',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PD,
    machine: 'Fill, WPK, STK',
    workCenterCategories: ['Z004', 'Z006', 'Z007']
  },
  {
    code: '3001',
    activity: 'ทดลองการผลิต  bulk',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.TRIAL_VALIDATION,
    machine: 'Mix, Storage, Fllter',
    workCenterCategories: ['Z001', 'Z002', 'Z009']
  },
  {
    code: '3002',
    activity: 'ทดลองการผลิต ด้วย PKG ใหม่',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.TRIAL_VALIDATION,
    machine: 'Shrink, Fill, WPK, STK, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z006', 'Z007', 'Z011']
  },
  {
    code: '9001',
    activity: 'PD ปรับเครื่องบรรจุ',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '9002',
    activity: 'PD ปรับเครื่องปิดฝา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fil',
    workCenterCategories: ['Z004']
  },
  {
    code: '9003',
    activity: 'PD เก็บขวดถูกบีบ เสียรูป แตก',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '9004',
    activity: 'PD ปรับเครื่องติดฉลาก',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Shrink, Fill, WPK, STK, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z007', 'Z011']
  },
  {
    code: '9005',
    activity: 'PD ปรับเครื่องชั่งชิ้นสินค้า',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '9006',
    activity: 'PD ปรับเครื่องยิง Lot / Laser',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, WPK, FFS',
    workCenterCategories: ['Z004', 'Z006', 'Z011']
  },
  {
    code: '9007',
    activity: 'PD ปรับเครื่อง Shrink',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Shrink, Fill, WPK',
    workCenterCategories: ['Z003', 'Z004', 'Z006']
  },
  {
    code: '9008',
    activity: 'PD ปรับเครื่องบรรจุกล่อง/ปิดกล่อง',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, WPK, FFS',
    workCenterCategories: ['Z004', 'Z006', 'Z011']
  },
  {
    code: '9009',
    activity: 'PD ปรับเครื่องชั่งกล่อง',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, WPK, FFS',
    workCenterCategories: ['Z004', 'Z006', 'Z011']
  },
  {
    code: '9010',
    activity: 'PD ปรับชุดหนีบ Spout มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '9011',
    activity: 'PD ปรับอุปกรณ์อื่นๆ',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '9012',
    activity: 'PD ปรับเครื่องซีลแนวตั้ง/แนวนอน',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, WPK, FFS',
    workCenterCategories: ['Z004', 'Z006', 'Z011']
  },
  {
    code: '9013',
    activity: 'PD ปรับกิ๊ฟจับปากซอง ปรับระยะซอง',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '9014',
    activity: 'PD ปรับกรรไกรมีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '9015',
    activity: 'PD ปรับกระดูกงูมีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '9016',
    activity: 'PD ปรับชุด Feed Film - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '9017',
    activity: 'PD ปรับชุดเจาะ Free Shape - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '9018',
    activity: 'PD ปรับชุดเจาะรูพั้นช์ - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '9019',
    activity: 'PD ปรับชุดตัดมุมก้นซอง - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '9020',
    activity: 'PD ปรับซีลก้นซอง - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '9021',
    activity: 'PD ปรับซีลข้างซอง - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '9022',
    activity: 'PD ปรับชุดเปิดปากซอง - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '9023',
    activity: 'PD ปรับซีลปากซอง - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '9024',
    activity: 'PD Copy รอยซีลตรวจสอบ',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '9025',
    activity: 'PD เก็บซองเปล่า ซองไม่กาง',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '9026',
    activity: 'PD ปรับขาแคม มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '9027',
    activity: 'PD ปรับ Cobot',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '9028',
    activity: 'PD ปรับ Palletizer มีปัญหาต้องปรับจูน',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '9029',
    activity: 'PD ปรับเครื่อง Shrink PK3',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, WPK',
    workCenterCategories: ['Z004', 'Z006']
  },
  {
    code: '9030',
    activity: 'PD ปรับจูนเครื่องพับกล่อง',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '9031',
    activity: 'PD ปรับ Plate Heat มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Mix, Stirage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '9032',
    activity: 'PD ปรับ Pump ส่ง bulk มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Mix, Storage, Fill, Filter, FFS',
    workCenterCategories: ['Z001', 'Z002', 'Z004', 'Z009', 'Z011']
  },
  {
    code: '9033',
    activity: 'PD ปรับโปรแกรม Scada',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Mix, Storage, Filter',
    workCenterCategories: ['Z001', 'Z002', 'Z009']
  },
  {
    code: '9034',
    activity: 'PD ปรับถัง storage มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Storage, Filter',
    workCenterCategories: ['Z002', 'Z009']
  },
  {
    code: '9035',
    activity: 'PD ปรับถัง Premix มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Mix, Storage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '9036',
    activity: 'PD ปรับถัง Mix มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.ADJUST_PD,
    machine: 'Mix',
    workCenterCategories: ['Z001']
  },
  {
    code: '5001',
    activity: 'หยุดซ่อม เครื่องบรรจุมีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '5002',
    activity: 'หยุดซ่อม เครื่องปิดฝามีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Fill',
    workCenterCategories: ['Z004']
  },
  {
    code: '5003',
    activity: 'หยุดซ่อม เครื่องติดฉลากมีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'shrink, Fill, Stk, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z007', 'Z011']
  },
  {
    code: '5004',
    activity: 'หยุดซ่อม เครื่องชั่งชิ้นสินค้ามีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '5005',
    activity: 'หยุดซ่อม เครื่องยิง Lot / Laser',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Fill, WPK, FFS',
    workCenterCategories: ['Z004', 'Z006', 'Z011']
  },
  {
    code: '5006',
    activity: 'หยุดซ่อม เครื่อง Shrink มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Shrink, Fill, WPK',
    workCenterCategories: ['Z003', 'Z004', 'Z006']
  },
  {
    code: '5007',
    activity: 'หยุดซ่อม เครื่องบรรจุกล่อง/ปิดกล่องมีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Fill, WPK, FFS',
    workCenterCategories: ['Z004', 'Z006', 'Z011']
  },
  {
    code: '5008',
    activity: 'หยุดซ่อม เครื่องชั่งกล่องมีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Fill, WPK, FFS',
    workCenterCategories: ['Z004', 'Z006', 'Z011']
  },
  {
    code: '5009',
    activity: 'หยุดซ่อม ชุดหนีบ Spout มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '5010',
    activity: 'หยุดซ่อม ถัง storage มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Storage, Filter',
    workCenterCategories: ['Z002', 'Z009']
  },
  {
    code: '5011',
    activity: 'หยุดซ่อม ถัง Premix มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Mix, Storage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '5012',
    activity: 'หยุดซ่อม ถัง Mix มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Mix',
    workCenterCategories: ['Z001']
  },
  {
    code: '5013',
    activity: 'หยุดซ่อม Shaer Pump - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Mix, Storage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '5014',
    activity: 'หยุดซ่อม อุปกรณ์อื่นๆมีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '5015',
    activity: 'หยุดซ่อม Cobot มีปัญหาเครื่องหยุด',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '5016',
    activity: 'หยุดซ่อม Palletizer มีปัญหาเครื่องหยุด',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '5017',
    activity: 'หยุดซ่อม เครื่อง Shrink PK3 มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Fill, WPK',
    workCenterCategories: ['Z004', 'Z006']
  },
  {
    code: '5018',
    activity: 'หยุดซ่อม เครื่องพับกล่องมีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '5019',
    activity: 'หยุดซ่อม Plate Heat มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Mix, Stirage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '5020',
    activity: 'หยุดซ่อม Pump ส่ง bulk มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Mix, Storage, Fill, Filter, FFS',
    workCenterCategories: ['Z001', 'Z002', 'Z004', 'Z009', 'Z011']
  },
  {
    code: '5021',
    activity: 'หยุดซ่อม เครื่องซีลแนวตั้ง/แนวนอน',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Fill, WPK, FFS',
    workCenterCategories: ['Z004', 'Z006', 'Z011']
  },
  {
    code: '5022',
    activity: 'หยุดซ่อม กรรไกรมีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '5023',
    activity: 'หยุดซ่อม กระดูกงูมีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '5024',
    activity: 'หยุดซ่อม ชุด Feed Film - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '5025',
    activity: 'หยุดซ่อม ชุดเจาะ Free Shape - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '5026',
    activity: 'หยุดซ่อม ชุดเจาะรูพั้นช์ - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '5027',
    activity: 'หยุดซ่อม ชุดตัดมุมก้นซอง - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '5028',
    activity: 'หยุดซ่อม ซีลก้นซอง - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '5029',
    activity: 'หยุดซ่อม ซีลข้างซอง - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'FFS',
    workCenterCategories: ['Z011']
  },
  {
    code: '5030',
    activity: 'หยุดซ่อม ชุดเปิดปากซอง - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '5031',
    activity: 'หยุดซ่อม ชุดซีลปากซอง - มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.BREAKDOWN_EN,
    machine: 'Fill, FFS',
    workCenterCategories: ['Z004', 'Z011']
  },
  {
    code: '5032',
    activity: 'ไฟดับ',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.UTILITY_FACILITY,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '5033',
    activity: 'ลมตก',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.UTILITY_FACILITY,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '5034',
    activity: 'รอน้ำ DI',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.UTILITY_FACILITY,
    machine: 'mix, Storage, Fill, FFS',
    workCenterCategories: ['Z001', 'Z002', 'Z004', 'Z011']
  },
  {
    code: '5035',
    activity: 'รอ Steam',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.UTILITY_FACILITY,
    machine: 'mix, Storage, Fill, FFS',
    workCenterCategories: ['Z001', 'Z002', 'Z004', 'Z011']
  },
  {
    code: '5036',
    activity: 'รอน้ำร้อน',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.UTILITY_FACILITY,
    machine: 'mix, Storage, Fill, FFS',
    workCenterCategories: ['Z001', 'Z002', 'Z004', 'Z011']
  },
  {
    code: '5037',
    activity: 'รอ Cooling / Chiller',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.UTILITY_FACILITY,
    machine: 'mix, Storage, Fill, FFS',
    workCenterCategories: ['Z001', 'Z002', 'Z004', 'Z011']
  },
  {
    code: '5038',
    activity: 'ลิฟท์ เสีย',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.UTILITY_FACILITY,
    machine: 'All Machine Mix & Fill',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '8001',
    activity: 'Supplier/EN/PM เข้ามาแก้ไข,ติดตั้งอุปกรณ์',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.PLAN,
    lossGroup: LossGroup.OTHER,
    machine: 'Other',
    workCenterCategories: ['Z001', 'Z002', 'Z003', 'Z004', 'Z006', 'Z007', 'Z009', 'Z011']
  },
  {
    code: '4001',
    activity: 'RM จาก tank farm มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.WAREHOUSE,
    machine: 'Mix, Storage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '4002',
    activity: 'ASRS มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.WAREHOUSE,
    machine: 'Fill, WPK, FFS',
    workCenterCategories: ['Z004', 'Z006', 'Z011']
  },
  {
    code: '4003',
    activity: 'รอ WH จ่าย RM / รอเปลี่ยน RM',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.WAREHOUSE,
    machine: 'Mix, Storage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '4004',
    activity: 'รอ WH จ่าย PK / รอเปลี่ยน PK',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.WAREHOUSE,
    machine: 'Shrink, Fill, WPK, STK, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z006', 'Z007', 'Z011']
  },
  {
    code: '4005',
    activity: 'รอ WH จ่ายพาเลท',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.WAREHOUSE,
    machine: 'Fill, WPK, FFS',
    workCenterCategories: ['Z004', 'Z006', 'Z011']
  },
  {
    code: '6001',
    activity: 'RM มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.QC,
    machine: 'Mix, Storage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '6002',
    activity: 'Package มีปัญหา',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.QC,
    machine: 'Shrink, Fill, WPK, STK, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z006', 'Z007', 'Z011']
  },
  {
    code: '6003',
    activity: 'รอสรุป Bulk มีปัญหาจาก RM',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.QC,
    machine: 'Mix, Storage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '6004',
    activity: 'รอ Bulk Passs (30&45 min)',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.QC,
    machine: 'Mix, Storage, Fill, FFS',
    workCenterCategories: ['Z001', 'Z002', 'Z004', 'Z011']
  },
  {
    code: '6005',
    activity: 'รอ RM Passs',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.QC,
    machine: 'Mix, Storage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '6006',
    activity: 'รอ PK Pass / รอตัดสินใจปัญหา PK',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.QC,
    machine: 'Shrink, Fill, WPK, STK, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z006', 'Z007', 'Z011']
  },
  {
    code: '6007',
    activity: 'แก้งาน/คัดงานมีปัญหา ของ QC',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.QC,
    machine: 'Shrink, Fill, WPK, STK, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z006', 'Z007', 'Z011']
  },
  {
    code: '6008',
    activity: 'รอตรวจสอบคุณภาพ Bulk เพิ่มพิเศษ',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.QC,
    machine: 'Mix, Storage, Filter',
    workCenterCategories: ['Z001', 'Z002', 'Z009']
  },
  {
    code: '6009',
    activity: 'รอ Standard FG',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.QC,
    machine: 'Shrink, Fill, WPK, STK, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z006', 'Z007', 'Z011']
  },
  {
    code: '7001',
    activity: 'รอ Raw Mat เข้า',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PURCHASING,
    machine: 'Mix, Storage',
    workCenterCategories: ['Z001', 'Z002']
  },
  {
    code: '7002',
    activity: 'รอ Pack Mat เข้า',
    timeType: OperationTime.DOWN_TIME,
    type: ReasonType.UNPLAN,
    lossGroup: LossGroup.PURCHASING,
    machine: 'Shrink, Fill, WPK, STK, FFS',
    workCenterCategories: ['Z003', 'Z004', 'Z006', 'Z007', 'Z011']
  }
]

// เอาเฉพาะกลุ่มที่มี code อยู่จริง เรียงตามที่เจอใน ReasonCodes
export const findLossGroups = (timeType, workCenterCategory) =>
  [...new Set(findReasonCodes(timeType, null, workCenterCategory).map(rc => rc.lossGroup))]

export const findLossGroupByCode = (code) =>
  ReasonCodes.find(rc => rc.code === code)?.lossGroup

// lossGroup / workCenterCategory ที่เป็นค่าว่างแปลว่าไม่กรอง
export const findReasonCodes = (timeType, lossGroup, workCenterCategory) =>
  ReasonCodes.filter(rc =>
    rc.timeType === timeType &&
    (!lossGroup || rc.lossGroup === lossGroup) &&
    (!workCenterCategory || rc.workCenterCategories.includes(workCenterCategory)))

export const OrderNoteDisplays = {
  ALL: 'ไม่ระบุ',
  TRIAL_BATCH: 'Trial Batch'
}

export const OrderNotes = {
  ALL: 'ALL',
  TRIAL_BATCH: 'TRIAL_BATCH'
}